import React, { useEffect, useRef } from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

import { InsightsDrawer } from './InsightsDrawer';

export const InsightsFullDrawerRender = () => {
  const { params } = useQueryParams();
  const { trackInsightsDrawerOpen } = usePosthogEvents();
  const trackedEntitiesRef = useRef<Set<string>>(new Set());

  const entityTagFromParams = params[queryKeys.entityTag];
  const activeDrawer = params[queryKeys.activeDrawer];
  const activeInsightId = params[queryKeys.activeInsightId];
  const utmSource = params[queryKeys.utmSource];

  const isDrawerOpen =
    entityTagFromParams &&
    activeDrawer === queryValues.insightsFullDrawer &&
    activeInsightId;

  useEffect(() => {
    if (!isDrawerOpen) {
      if (entityTagFromParams) {
        trackedEntitiesRef.current.delete(entityTagFromParams);
      }

      return;
    }

    if (
      entityTagFromParams &&
      utmSource &&
      !trackedEntitiesRef.current.has(entityTagFromParams)
    ) {
      trackedEntitiesRef.current.add(entityTagFromParams);
      trackInsightsDrawerOpen(utmSource as PosthogTrackingSource, 'full', {});
    }
  }, [isDrawerOpen, entityTagFromParams, utmSource]);

  if (entityTagFromParams && activeDrawer === queryValues.insightsFullDrawer) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <InsightsDrawer
          key={entityTagFromParams}
          entityTag={entityTagFromParams}
        />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
